
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutbpeB0pHlp_SDPgddjTg8KQ6dzjZQ2TOcvb_TtdyW5kwMeta } from "/workspace/pages/about.vue?macro=true";
import { default as contactFj0aNoRPJSXxj4SXLABzquCnprKOdtFKISUHdP_nOroMeta } from "/workspace/pages/contact.vue?macro=true";
import { default as cookie_45policyjBLeU7pJTDKB9EZD01ZXupT4BUzOrF8UeVqt0tzDXg0Meta } from "/workspace/pages/cookie-policy.vue?macro=true";
import { default as privacy_45policyehTun0WVymz3_9ViU0ZT_U7AgH2xis5SuclzChbG0VQMeta } from "/workspace/pages/privacy-policy.vue?macro=true";
import { default as terms_45of_45serviceRgQoY7L3seit7hhJ9i95o7uYTht4dJNwPfHT6gbUJ6kMeta } from "/workspace/pages/terms-of-service.vue?macro=true";
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as component_45stubmY_0xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta } from "/workspace/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubmY_0xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I } from "/workspace/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___ar",
    path: "/about/",
    meta: aboutbpeB0pHlp_SDPgddjTg8KQ6dzjZQ2TOcvb_TtdyW5kwMeta || {},
    component: () => import("/workspace/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about/",
    meta: aboutbpeB0pHlp_SDPgddjTg8KQ6dzjZQ2TOcvb_TtdyW5kwMeta || {},
    component: () => import("/workspace/pages/about.vue")
  },
  {
    name: "contact___ar",
    path: "/contact/",
    meta: contactFj0aNoRPJSXxj4SXLABzquCnprKOdtFKISUHdP_nOroMeta || {},
    component: () => import("/workspace/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact/",
    meta: contactFj0aNoRPJSXxj4SXLABzquCnprKOdtFKISUHdP_nOroMeta || {},
    component: () => import("/workspace/pages/contact.vue")
  },
  {
    name: "cookie-policy___ar",
    path: "/cookie-policy/",
    meta: cookie_45policyjBLeU7pJTDKB9EZD01ZXupT4BUzOrF8UeVqt0tzDXg0Meta || {},
    component: () => import("/workspace/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___en",
    path: "/en/cookie-policy/",
    meta: cookie_45policyjBLeU7pJTDKB9EZD01ZXupT4BUzOrF8UeVqt0tzDXg0Meta || {},
    component: () => import("/workspace/pages/cookie-policy.vue")
  },
  {
    name: "privacy-policy___ar",
    path: "/privacy-policy/",
    meta: privacy_45policyehTun0WVymz3_9ViU0ZT_U7AgH2xis5SuclzChbG0VQMeta || {},
    component: () => import("/workspace/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy/",
    meta: privacy_45policyehTun0WVymz3_9ViU0ZT_U7AgH2xis5SuclzChbG0VQMeta || {},
    component: () => import("/workspace/pages/privacy-policy.vue")
  },
  {
    name: "terms-of-service___ar",
    path: "/terms-of-service/",
    meta: terms_45of_45serviceRgQoY7L3seit7hhJ9i95o7uYTht4dJNwPfHT6gbUJ6kMeta || {},
    component: () => import("/workspace/pages/terms-of-service.vue")
  },
  {
    name: "terms-of-service___en",
    path: "/en/terms-of-service/",
    meta: terms_45of_45serviceRgQoY7L3seit7hhJ9i95o7uYTht4dJNwPfHT6gbUJ6kMeta || {},
    component: () => import("/workspace/pages/terms-of-service.vue")
  },
  {
    name: "index___ar",
    path: "/",
    meta: indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_dfSAMeta || {},
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en/",
    meta: indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_dfSAMeta || {},
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: component_45stubmY_0xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/sitemap.xml/",
    component: component_45stubmY_0xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_0xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/en/sitemap.xml/",
    component: component_45stubmY_0xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  }
]